import type React from 'react';
import { cx } from '@/styled-system/css';
import Linker from 'app/shared/modules/Linker';
import { shouldShowTotalMonthlyPriceBadge } from 'app/shared/utils/totalMonthlyPriceUtils';
import { learnMoreLinkStyles, totalMonthlyPriceNoticeStyles } from './styles';
import type { TotalMonthlyPriceNoticeProps } from './types';
import pathsManifest from 'app/shared/utils/pathsManifest';

const TotalMonthlyPriceNotice: React.FC<TotalMonthlyPriceNoticeProps> = ({
  listing,
  className,
  'data-testid': testId,
}) => {
  // Early return if conditions not met for Total Monthly Price features
  if (!shouldShowTotalMonthlyPriceBadge(listing)) {
    return null;
  }

  // Determine notice type based on API field
  const hasTotalMonthlyPrice = Boolean(listing.hasTotalMonthlyPrice);

  if (hasTotalMonthlyPrice) {
    return (
      <div className={cx(totalMonthlyPriceNoticeStyles, className)} data-testid={testId}>
        This listing now includes required monthly fees in the total price.{' '}
        <Linker
          href={pathsManifest.learnMoreAboutTotalMonthlyPrice}
          className={learnMoreLinkStyles}
          data-testid={testId ? `${testId}-learn-more` : 'learn-more-link'}
        >
          Learn more
        </Linker>
      </div>
    );
  }

  return (
    <div className={cx(totalMonthlyPriceNoticeStyles, className)} data-testid={testId}>
      Price may not include required fees and charges.
    </div>
  );
};

export default TotalMonthlyPriceNotice;
